<template>
	<div class="flex-shrink-0 flex items-top w-full overflow-hidden relative">
		<img
			v-if="props.photo"
			class="w-full aspect-square"
			:alt="props.nombre"
			:src="props.photo"
		/>
		<div
			v-else
			class="w-full h-full bg-accent-green-0.5 flex items-center justify-center"
		>
			<img
				class="w-full aspect-square"
				style="padding: 10%"
				src="../assets/gato_duda.svg"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProductPhotoComponent',
	props: {
		photo: {
			type: String,
			default: null,
			required: false
		}
	},
	setup(props) {
		return {
			props
		}
	}
}
</script>
